import React from 'react';
import { getLeagueName } from '../../services/leagueService';
import { getTeamName } from '../../services/teamService';
import { Language } from '../../types';

interface HotMatchSliderProps {
  hotMatches: any[];
  lang: string;
}

export const HotMatchSlider: React.FC<HotMatchSliderProps> = ({ hotMatches, lang }) => {
  if (hotMatches.length === 0) return null;

  return (
    <div className="py-6 border-b border-gray-100 bg-white">
      <div className="flex overflow-x-auto no-scrollbar gap-4 px-6 snap-x">
        {hotMatches.map((match) => (
          <div 
            key={match.id}
            onClick={() => window.navigateTo(`/game/${match.id}`)}
            className="flex-shrink-0 w-[240px] group cursor-pointer snap-center"
          >
            <div className="relative bg-white rounded-2xl border border-slate-100 p-4 shadow-sm">
              {/* Match Info Header */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-tight">
                  {getLeagueName(Number(match.league), lang as Language, match.leagueName || 'Match')}
                </span>
                {match.status === 'Live' ? (
                  <div className="flex items-center gap-1.5 bg-rose-50 px-2 py-0.5 rounded-full">
                    <span className="w-1 h-1 rounded-full bg-rose-500 animate-pulse" />
                    <span className="text-[9px] font-black text-rose-600 uppercase italic">Live</span>
                  </div>
                ) : (
                  <span className="text-[9px] font-black text-slate-400">
                    {match.status === 'Scheduled' ? match.time : 'FT'}
                  </span>
                )}
              </div>

              {/* Teams and Score */}
              <div className="flex items-center justify-between gap-2">
                <div className="flex flex-col items-center flex-1 gap-2">
                  <img 
                    src={match.homeTeam.logo} 
                    alt="" 
                    className="w-10 h-10 object-contain drop-shadow-sm " 
                  />
                  <span className="text-[10px] font-bold text-slate-900 text-center line-clamp-1">
                    {getTeamName(match.homeTeam.id, lang as Language, match.homeTeam.name)}
                  </span>
                </div>

                <div className="flex flex-col items-center px-2">
                  <div className="text-lg font-black text-slate-900 flex items-center gap-1.5">
                    {match.status === 'Scheduled' ? (
                      <span className="text-slate-200 text-sm italic">VS</span>
                    ) : (
                      <>
                        <span className={match.homeTeam.score > match.awayTeam.score ? 'text-rose-500' : ''}>
                          {match.score?.split('-')[0] || 0}
                        </span>
                      </>
                    )}
                  </div>
                </div>

                <div className="flex flex-col items-center flex-1 gap-2">
                  <img 
                    src={match.awayTeam.logo} 
                    alt="" 
                    className="w-10 h-10 object-contain drop-shadow-sm" 
                  />
                  <span className="text-[10px] font-bold text-slate-900 text-center line-clamp-1">
                    {getTeamName(match.awayTeam.id, lang as Language, match.awayTeam.name)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
